<!-- Truncated display-->
<ng-container *ngIf="truncate">
  <div class="highlighted-topline highlighted-topline--note">
    <div *ngIf="topline?.appliedToplineValue"
         class="truncate">
      <span class="pr-0025">
        <i class="fal fa-fw fa-sticky-note"
           matTooltip="Note"></i>
      </span>

      <span *ngIf="topline?.appliedToplineValue"
            style="text-overflow:ellipsis"
            class="color--gray--007 txt-fw-500">
        {{topline.appliedToplineValue.text}}
      </span>

    </div>
  </div>
</ng-container>

<ng-container *ngIf="!truncate">
  <div class="toplines__pair toplines__pair--note col__ flexAlign--baseline"
       [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue}">
    <div class="pair__icon">
      <i class="fal fa-fw fa-sticky-note"
         matTooltip="Note"></i>
    </div>

    <div class="pair__content truncate">
      <button type="button"
              *ngIf="!topline?.appliedToplineValue"
              (click)="onAddClicked()"
              class="pair__link link link--noline p-0">
        Add Note
      </button>
      <div class="flag__card"
           *ngIf="topline?.appliedToplineValue">
        <app-view-note class="d-block note"
                       [viewAllMenuItemVisible]="true"
                       (viewAllNotesClicked)="viewAllNotesClicked($event)"
                       [truncateEnabled]="true"
                       [note]="topline?.appliedToplineValue"
                       [noteCampaignId]="campaignId"
                       [targetType]="'Entity'"
                       [targetId]="targetId"></app-view-note>
      </div>

    </div>
  </div>
</ng-container>
